
      import API from "!../../style-loader/dist/runtime/injectStylesIntoStyleTag.js";
      import domAPI from "!../../style-loader/dist/runtime/styleDomAPI.js";
      import insertFn from "!../../style-loader/dist/runtime/insertBySelector.js";
      import setAttributes from "!../../style-loader/dist/runtime/setAttributesWithoutAttributes.js";
      import insertStyleElement from "!../../style-loader/dist/runtime/insertStyleElement.js";
      import styleTagTransformFn from "!../../style-loader/dist/runtime/styleTagTransform.js";
      import content, * as namedExport from "!!../../css-loader/dist/cjs.js??ruleSet[1].rules[4].use[1]!./virtualFileLoader/dist/vanilla-extract-webpack-plugin-virtualFileLoader.cjs.js?{\"fileName\":\"app/pages/book-delivery/partials/changing-slot-warning-modal/styles.css.ts.vanilla.css\",\"source\":\"Ll8xNWdvdjBjMCB7CiAgYm9yZGVyLXRvcDogMnB4IHNvbGlkIHZhcigtLV8xOHc3NmJ3MjgpOwp9CkBtZWRpYSBzY3JlZW4gYW5kIChtaW4td2lkdGg6IDEwMjRweCkgewogIC5fMTVnb3YwYzEgewogICAgbWF4LXdpZHRoOiAyMjBweDsKICB9Cn0=\"}!./extracted.js";
      
      

var options = {};

options.styleTagTransform = styleTagTransformFn;
options.setAttributes = setAttributes;

      options.insert = insertFn.bind(null, "head");
    
options.domAPI = domAPI;
options.insertStyleElement = insertStyleElement;

var update = API(content, options);



export * from "!!../../css-loader/dist/cjs.js??ruleSet[1].rules[4].use[1]!./virtualFileLoader/dist/vanilla-extract-webpack-plugin-virtualFileLoader.cjs.js?{\"fileName\":\"app/pages/book-delivery/partials/changing-slot-warning-modal/styles.css.ts.vanilla.css\",\"source\":\"Ll8xNWdvdjBjMCB7CiAgYm9yZGVyLXRvcDogMnB4IHNvbGlkIHZhcigtLV8xOHc3NmJ3MjgpOwp9CkBtZWRpYSBzY3JlZW4gYW5kIChtaW4td2lkdGg6IDEwMjRweCkgewogIC5fMTVnb3YwYzEgewogICAgbWF4LXdpZHRoOiAyMjBweDsKICB9Cn0=\"}!./extracted.js";
       export default content && content.locals ? content.locals : undefined;
